export default __webpack_public_path__ + "static/OldmanSeaFishing-3c2f8ce0d4c2dd2b2c3f3cbc65ff354b.png";